import { graphql } from 'react-relay';
export const SpaceMetadataQuery = graphql`
	query SpaceMetadataQuery($id: Long!) {
		spaces(spaceId: $id) {
			nodes {
				homepage {
					id
				}
			}
		}
	}
`;
